export default "__VITE_ASSET__DMShJnHX__"